const PricingSection = () => {
    return (<stripe-pricing-table pricing-table-id="prctbl_1NoTZBAoggFEIIlJQN2rECfa" publishable-key="pk_live_51HEmwuAoggFEIIlJM98xBrqvrlf5Mos71JuKF1YNRSpNIheKANy5IlGq0jDQUNj4wkNQAiDl9XIB82XYcZtgNr3800IniJzM72">
    </stripe-pricing-table>  );
}
 
export default PricingSection;